import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import _ from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

interface Breadcrumb {
  label: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppCustomBreadcrumbService {
  public breadcrumbs: Observable<Array<any>>;
  private breadcrumbSubject: BehaviorSubject<Array<any>>;

  constructor(private router: Router, private route: ActivatedRoute) {
    this.breadcrumbSubject = new BehaviorSubject<any[]>(new Array<any>());

    this.breadcrumbs = this.breadcrumbSubject.asObservable();

    // NavigationEnd
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        let breadcrumbs: Array<Breadcrumb> = [];
        let currentRoute: ActivatedRoute | null = this.route.root;
        let url = '';
        do {
          const childrenRoutes = currentRoute.children;
          currentRoute = null;

          childrenRoutes.forEach(route => {
            if (route.outlet === 'primary') {
              const routeSnapshot = route.snapshot;
              url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
              if (url.charAt(url.length - 1) === '/') {
                url = url.substring(0, url.length - 1);
              }
              breadcrumbs = _.unionBy(breadcrumbs, [{ label: routeSnapshot.data['title'], url: url.replaceAll("//", "/") }], "url");
              currentRoute = route;
            }
          });
        } while (currentRoute);
        this.breadcrumbSubject.next([...breadcrumbs]);

        return breadcrumbs;
      });
  }
}
